import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/applicative'

export const applicativeService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    metricsByApp,
    generateMetrics,
    translateModule
};

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

function metricsByApp(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/metricsByApp`, 'POST', { data, showAlert:false })
}

function generateMetrics(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/metrics`, 'POST', { data, showAlert:false })
}

function translateModule(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/module`, 'POST', { data, showAlert:true })
}